import { IconType } from 'react-icons';
import {
  BsFiletypePng,
  BsFiletypePdf,
  BsFiletypeJpg,
  BsFileEarmarkText,
} from 'react-icons/bs';

const getFileIcon = (fileName: string): IconType => {
  let Component = BsFileEarmarkText;
  try {
    const documentExtention: string = fileName.split('.').pop()?.toLowerCase() || '';
    if (documentExtention === 'png') {
      Component = BsFiletypePng;
    } else if (documentExtention === 'jpeg' || documentExtention === 'jpg') {
      Component = BsFiletypeJpg;
    } else if (documentExtention === 'pdf') {
      Component = BsFiletypePdf;
    }
  } catch (e: unknown) {
    console.error(e);
  }
  return Component;
};

const getFileName = (fileName: string, nameLength?: number): {
  name: string;
  extension: string;
} => {
  try {
    const names = fileName.split('.');
    const [name] = names;
    return {
      name: name.slice(0, nameLength || 25),
      extension: names.pop()?.trim() || '',
    };
  } catch (e: unknown) {
    return {
      name: '',
      extension: '',
    };
  }
};

export {
  getFileName,
  getFileIcon,
};
